/**
 * Estado de la estimación de carga que sobrevive al cambio de módulo (la página de compras se desmonta al
 * navegar). Vive en memoria del navegador: un refresco de la pestaña lo descarta. Guarda un único ámbito
 * (almacén + proveedores); si el ámbito cambia, no se restaura.
 */
let snapshot: { key: string; value: unknown } | null = null;

export function readEstimateSnapshot<T>(key: string): T | null {
  return snapshot && snapshot.key === key ? (snapshot.value as T) : null;
}

export function writeEstimateSnapshot(key: string, value: unknown): void {
  snapshot = { key, value };
}

export function clearEstimateSnapshot(): void {
  snapshot = null;
}
